import { useLocale } from 'use-intl';

import { SupportedLocale } from './types';
import { normalizeLocale } from './utils';

/**
 * Client-only. Import from `use-intl` (not `next-intl`) so Vite/Storybook
 * prebundles don't drop `useLocale` via next-intl's `export * from 'use-intl'`.
 */
export function useSupportedLocale(): SupportedLocale {
  const locale = useLocale();
  return normalizeLocale(locale);
}
